import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/25.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Zsiadasz z wozu, żeby zagadać do starego Tornaua"
            question="O co chcesz zapytać starego Tornaua?"
            audio={audio}
            answers={{
                ans1: "Po co ci łódka?",
                ans2: "Czemu nazywają cię Samotnym Olędrem?",
                ans3: "Dlaczego chodzisz sam wieczorem nad rzeką?"
            }}
            links={{
                link1: PAGES.p42,
                link2: PAGES.p43,
                link3: PAGES.p44
            }}
            content={
                <div>
                    <ul>
                        <li>Hej, zaczekaj! – krzyczysz do przygarbionej postaci między brzozami.
                            Buty po kilku susach na podmokłej trawie robią się zupełnie mokre i zaczynają rytmicznie chlupać. Stary Tornau nieruchomieje na chwilę, po czym rusza dalej wzdłuż rzeczki. Zauważasz, że ciągnie za sobą łódkę.
                        </li>
                        <li>Zaczekaj! – sapiesz, przebiegając przez lasek brzozowy. Nagle starzec odwraca się i patrzy ci prosto w oczy.</li>
                        <li>Po co ten pośpiech? – uśmiecha się dziwnie. – Co nagle, to po diable!
                            Zapada niezręczna cisza.
                        </li>
                        <li>Chcę tylko porozmawiać – zagajasz.</li>
                    </ul>
                </div>
            }
        />

    );
}